<template>
  <div class="mainHome">
    <Header :moveToMenu="moveToMenu" :class="flgModeMenu ? 'dark' : ''" />
    <!-- <full-page ref="fullpage" :options="options" id="fullpage">
            
        </full-page> -->
    <div>
      <section class="section">
        <div class="section_1">
          <div class="section_banner" :class="[
      flgActive1 ? 'bg_1' : '',
      flgActive2 ? 'bg_2' : '',
      flgActive3 ? 'bg_3' : '',
    ]">
            <div class="banner">
              <div class="content">
                <img src="../assets/text.svg" alt="" />
                <p>
                  The first-class NFT collection with utilities on all products on Zyncas’s platform. Choose your unique
                  Zodiac Avatar, join the forces, and conquer the battlefield.
                </p>

                <!-- Button Buy NFT & How to buy -->
                <!-- <ul>
                  <li>
                    <a
                      href="https://app.signals.zyncas.com/zodiac-arena"
                      target="_blank"
                      >Buy NFT</a
                    >
                  </li>
                  <li><a href="https://token.zyncas.com" target="_blank">Token Page</a></li>
                  <li>
                    <router-link to="/how-to-buy" class="cta">
                      <span class="span">How To Buy</span>
                      <span class="second">
                        <svg
                          width="50px"
                          height="20px"
                          viewBox="0 0 66 43"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <g
                            id="arrow"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path
                              class="one"
                              d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                              fill="#FFFFFF"
                            ></path>
                            <path
                              class="two"
                              d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                              fill="#FFFFFF"
                            ></path>
                            <path
                              class="three"
                              d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                              fill="#FFFFFF"
                            ></path>
                          </g>
                        </svg>
                      </span>
                    </router-link> 
                  </li>
                </ul> -->

              </div>
              <ul class="img_banner">
                <li :class="flgActive1 ? 'active' : ''" @click="changeBanner(1)">
                  <img src="../assets/banner_1.png" alt="" />
                </li>
                <li :class="flgActive2 ? 'active' : ''" @click="changeBanner(2)">
                  <img src="../assets/banner_2.png" alt="" />
                </li>
                <li :class="flgActive3 ? 'active' : ''" @click="changeBanner(3)">
                  <img src="../assets/banner_3.png" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="countdownTime">
        <CountDownTime />
      </section>
      <section class="section" id="roadmap">
        <Roadmap />
      </section>
      <section class="section" id="utility">
        <Utility />
      </section>
      <section class="section" id="tokenomic">
        <Tokenomic />
      </section>
      <section class="section">
        <Warriors />
      </section>
      <section class="section" id="storyline">
        <AboutStory />
      </section>
      <section class="section" id="team">
        <Team />
      </section>
      <div class="floating-button-container">
        <router-link to="/minigame" class="floating-button">
          <div class="icon">
            <img src="../assets/money.png" alt="Lucky Wheel Icon">
          </div>
          <div class="text">Join Lucky Wheel Mini Game</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import FullPage from 'vue-fullpage.js/src/FullPage';
import Header from "@/components/Header.vue";
import AboutStory from "@/components/AboutStory.vue";
import Warriors from "@/components/Warriors.vue";
import Utility from "@/components/Utility.vue";
import Roadmap from "@/components/Roadmap.vue";
import Team from "@/components/Team.vue";
import Tokenomic from "@/components/Tokenomic.vue";
import CountDownTime from "@/components/CountDownTime.vue";
import Progress from "@/components/Progress.vue";

export default {
  components: {
    Header,
    // FullPage,
    AboutStory,
    Warriors,
    Utility,
    Roadmap,
    Team,
    Tokenomic,
    Progress,
    CountDownTime
  },

  data() {
    return {
      flgActive1: true,
      flgActive2: false,
      flgActive3: false,
      flgModeMenu: false,
      flgStory: false,
      flgUtility: false,
      flgRoadmap: false,
      flgTeam: false,
      flgTokenomic: false,
      // options: {
      // setAllowScrolling: false,
      // scrollBar: true,
      // licenseKey: 'YOUR_KEY_HERE',
      // scrollingSpeed: 1500,
      // responsiveWidth: 992,
      // autoScrolling: true,
      // easingcss3: 'ease',
      // onLeave: this.onLeave,
      // },
    };
  },
  methods: {
    changeBanner(item) {
      if (item == 1) {
        this.flgActive1 = true;
        this.flgActive2 = false;
        this.flgActive3 = false;
      } else if (item == 2) {
        this.flgActive1 = false;
        this.flgActive2 = true;
        this.flgActive3 = false;
      } else {
        this.flgActive1 = false;
        this.flgActive2 = false;
        this.flgActive3 = true;
      }
    },
    onLeave(origin, desti, direct) {
      // console.log('origin',origin);
      // console.log('desti',desti);
      // console.log('direct',direct);
      if (origin && direct) {
        this.flgModeMenu = true;
      }
      if (desti.index == 1) {
        this.flgStory = true;
        this.flgUtility = false;
        this.flgRoadmap = false;
        this.flgTeam = false;
        this.flgTokenomic = false;
        this.flgModeMenu = true;
      } else if (desti.index == 2) {
        this.flgStory = true;
        this.flgUtility = false;
        this.flgRoadmap = false;
        this.flgTeam = false;
        this.flgTokenomic = false;
        this.flgModeMenu = true;
      } else if (desti.index == 3) {
        this.flgStory = false;
        this.flgUtility = true;
        this.flgRoadmap = false;
        this.flgTeam = false;
        this.flgTokenomic = false;
        this.flgModeMenu = true;
      } else if (desti.index == 4) {
        this.flgStory = false;
        this.flgUtility = false;
        this.flgRoadmap = true;
        this.flgTeam = false;
        this.flgTokenomic = false;
        this.flgModeMenu = true;
      } else if (desti.index == 5) {
        this.flgStory = false;
        this.flgUtility = false;
        this.flgRoadmap = false;
        this.flgTeam = false;
        this.flgTokenomic = true;
        this.flgModeMenu = true;
      } else if (desti.index == 6) {
        this.flgStory = false;
        this.flgUtility = false;
        this.flgRoadmap = false;
        this.flgTeam = true;
        this.flgTokenomic = false;
        this.flgModeMenu = true;
      } else {
        this.flgStory = false;
        this.flgUtility = false;
        this.flgRoadmap = false;
        this.flgTeam = false;
        this.flgTokenomic = false;
        this.flgModeMenu = false;
      }
    },
    moveToMenu(section) {
      if (section == "storyline") {
        fullpage_api.moveTo(2);
      } else if (section == "utility") {
        fullpage_api.moveTo(4);
      } else if (section == "roadmap") {
        fullpage_api.moveTo(5);
      } else if (section == "tokenomic") {
        fullpage_api.moveTo(6);
      } else if (section == "team") {
        fullpage_api.moveTo(7);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.countdownTime {
  border-bottom: 1px solid #000;
}

.section_banner {
  transition: all 0.5s ease;

  &.bg_1 {
    background: url(../assets/bg_1.jpg) no-repeat;
    background-size: cover;
    background-position: center;
  }

  &.bg_2 {
    background: url(../assets/bg_2.jpg) no-repeat;
    background-size: cover;
    background-position: center;
  }

  &.bg_3 {
    background: url(../assets/bg_3.jpg) no-repeat;
    background-size: cover;
    background-position: center;
  }

  height: 100vh;

  @media (max-width: 992px) {
    height: auto;
    padding: 120px 0;
  }

  .banner {
    display: flex;
    width: 100%;
    padding: 0 60px;
    align-items: center;
    flex-wrap: nowrap;
    height: 100%;
    gap: 30px;

    .content {
      width: 40%;

      img {
        margin-bottom: 20px;
      }

      p {
        color: #fff;
        font-size: 18px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.87);
      }

      ul {
        display: flex;
        gap: 25px;
        align-items: center;
        height: 72px;
        padding: 10px 0;
        overflow: hidden;

        @media (max-width: 992px) {
          flex-wrap: wrap;
          justify-content: center;
          height: auto;
          width: 100%;
        }

        li {
          a {
            font-size: 16px;
            font-weight: 600;
            text-transform: uppercase;
            display: inline-block;
            text-align: center;
            line-height: 44px;
            text-decoration: none;
          }

          &:first-child {
            a {
              border: 1px solid #fff;
              background: #fff;
              height: 44px;
              width: 140px;
              color: #000;

              &:hover {
                color: #fff;
                background: #000;
                border: 1px solid #000;
              }
            }
          }

          &:last-child {
            a {
              color: #fff;
              padding-right: 0;

              &:hover {
                background: #fff;
                border: 1px solid #fff;
                color: #000;
              }
            }
          }
        }
      }
    }

    .img_banner {
      width: 60%;
      display: flex;
      gap: 30px;

      li {
        transition: all 0.5s ease;
        cursor: pointer;

        &:not(.active) {
          width: 45%;
          filter: grayscale(100%);
        }

        &.active {
          width: 100%;
          filter: grayscale(0%);
        }

        @media (min-width: 993px) {
          &:hover {
            width: 100%;
            filter: grayscale(0%);
          }
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }

        &:hover {
          filter: grayscale(0);
        }
      }
    }

    @media (max-width: 992px) {
      flex-direction: column;
      justify-content: center;
      padding: 0 20px;
      gap: 20px;

      .content {
        width: 100%;
        // padding-right: 50px;
        margin-bottom: 30px;

        img {
          width: 100%;
        }

        p {
          display: none;
        }
      }

      .img_banner {
        width: 100%;
        height: 278px;
        gap: 0;

        li {
          &:not(.active) {
            width: 20%;
          }
        }
      }
    }
  }

}

.floating-button-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  max-width: 10rem;
}

.floating-button {
  color: #00f043;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
}

.icon img {
  width: 6rem;
  height: 6rem;
}

.text {
  margin-top: 5px;
  font-size: 12px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .icon img {
    width: 3.5rem;
    height: 3.5rem;
  }

  .floating-button-container {
    max-width: 8rem;
    right: 8px;
  }

  .text {
    font-size: x-small;
  }
}
</style>